import { useState } from "react";
import { Steps } from "intro.js-react";
import { useSelector } from "react-redux";
import {
  getSelectedTour,
  getStartTour,
  removeTour,
  setStartTour,
} from "@/store/slices/tour/tourSlice";
import { useDispatch } from "react-redux";

const TourWrapper = () => {
  const [initialStep, setInitialStep] = useState(0);
  const startTour = useSelector(getStartTour);
  const getSteps = useSelector(getSelectedTour);
  const dispatch = useDispatch();

  const onExit = () => {
    const id = getSteps[0]?.id;
    let ele = document.getElementById(id);
    if (ele) ele.click();

    dispatch(setStartTour(false));
    dispatch(removeTour());
  };

  return (
    <div>
      <Steps
        enabled={startTour}
        steps={getSteps}
        initialStep={initialStep}
        onExit={onExit}
        options={{
          prevLabel: "Previous",
          showBullets: true,
          disableInteraction: true,
          exitOnEsc: false,
          exitOnOverlayClick: false,
          doneLabel: "Finish",
          // showStepNumbers: true,
        }}
      />
    </div>
  );
};

export default TourWrapper;
